import type { BoxProps, TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

import { ToastContainer } from './Notification.styled';

export type ButtonVariant = 'filled' | 'outlined';

export interface NotificationButtonAction {
  label: ReactNode;
  handler: VoidFunction;
  buttonVariant?: ButtonVariant;
  buttonStartIcon?: ReactNode;
}

export interface NotificationIconButtonAction {
  icon: ReactNode;
  handler: VoidFunction;
}

export type NotificationAction = NotificationButtonAction | NotificationIconButtonAction;

export interface ToastProps extends Omit<BoxProps, 'color'> {
  message: ReactNode;
  startIcon?: ReactNode;
  backgroundColor?: string;
  textColor?: string;
  actionsSlot?: ReactNode;
  typographyProps?: TypographyProps;
  'data-test-id'?: string;
}

export const Toast: FC<ToastProps> = ({
  message,
  startIcon,
  backgroundColor,
  textColor = 'white',
  actionsSlot,
  typographyProps,
  'data-test-id': dataTestId = 'notification',
  ...props
}) => {
  return (
    <ToastContainer backgroundColor={backgroundColor} data-test-id={dataTestId} {...props}>
      {startIcon}

      <Typography
        textAlign="center"
        color={textColor}
        variant="h3"
        whiteSpace="pre"
        {...typographyProps}
      >
        {message}
      </Typography>

      {actionsSlot}
    </ToastContainer>
  );
};
